import { render } from "./TSlandingPage.vue?vue&type=template&id=2d6b15b5"
import script from "./TSlandingPage.vue?vue&type=script&lang=js"
export * from "./TSlandingPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__